import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26db7b2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CreateVacancyForm__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, "Добавление вакансии", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_4 = { class: "CreateVacancyForm__content" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = { class: "flex justify-end items-center mt-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_alert = _resolveComponent("alert")!
  const _component_quill_editor = _resolveComponent("quill-editor")!

  return (_openBlock(), _createElementBlock("form", {
    class: "CreateVacancyForm",
    onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _ctx.emitCancel
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Отменить ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_the_input, {
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors,
        placeholder: "Название вакансии"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.salary_from,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.salary_from) = $event)),
        "is-invalid": _ctx.state_form$.salary_from.$error,
        "validation-errors": _ctx.state_form$.salary_from.$errors,
        placeholder: "Зарплата от"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.salary_to,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.salary_to) = $event)),
        "is-invalid": _ctx.state_form$.salary_to.$error,
        "validation-errors": _ctx.state_form$.salary_to.$errors,
        placeholder: "Зарплата до"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        value: _ctx.state.experience_id,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.experience_id) = $event)),
        placeholder: "Выберите требуемый опыт работы",
        "is-invalid": _ctx.state_form$.experience_id.$error,
        "validation-errors": _ctx.state_form$.experience_id.$errors,
        loading: _ctx.data_state.experience.is_loading,
        options: _ctx.data_state.experience.list,
        failed: _ctx.data_state.experience.is_failed,
        "error-text": "При получении списка опытов работы произошла ошибка",
        "search-by": "title",
        label: "title",
        "infinite-scroll": "",
        onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadExperience(_ctx.data_state.experience.pagination.current_page))),
        onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreExperience(_ctx.data_state.experience.pagination.current_page + 1)))
      }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed"]),
      _createVNode(_component_the_select, {
        value: _ctx.state.region_id,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.region_id) = $event)),
        placeholder: "Выберите регион",
        "is-invalid": _ctx.state_form$.region_id.$error,
        "validation-errors": _ctx.state_form$.region_id.$errors,
        loading: _ctx.data_state.regions.is_loading,
        options: _ctx.data_state.regions.list,
        failed: _ctx.data_state.regions.is_failed,
        "error-text": "При получении списка регионов произошла ошибка",
        "infinite-scroll": "",
        onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadRegions(_ctx.data_state.regions.pagination.current_page))),
        onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadMoreRegions(_ctx.data_state.regions.pagination.current_page + 1)))
      }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed"]),
      _createVNode(_component_the_select, {
        value: _ctx.state.category_id,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.category_id) = $event)),
        placeholder: "Выберите категорию",
        "is-invalid": _ctx.state_form$.category_id.$error,
        "validation-errors": _ctx.state_form$.category_id.$errors,
        loading: _ctx.data_state.categories.is_loading,
        options: _ctx.data_state.categories.list,
        failed: _ctx.data_state.categories.is_failed,
        "error-text": "При получении списка категорий произошла ошибка",
        "infinite-scroll": "",
        onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadCategories(_ctx.data_state.categories.pagination.current_page))),
        onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadMoreCategories(_ctx.data_state.categories.pagination.current_page + 1)))
      }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed"]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.state_form$.description.$error)
          ? (_openBlock(), _createBlock(_component_alert, {
              key: 0,
              class: "red mb-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Укажите описание ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_quill_editor, {
          contentType: "html",
          content: _ctx.state.description,
          "onUpdate:content": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.description) = $event)),
          options: { placeholder: 'Укажите описание вакансии' }
        }, null, 8, ["content"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_the_button, {
          type: "submit",
          class: "primary small",
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ])
  ], 32))
}